// Job-flow photo/checklist gating. The gate predicates and lock messages
// live in @shyne/shared (packages/shared/src/workflow-photo-gate.ts) so the
// web and mobile UIs enforce the same sequence with the same messages by
// construction; this module re-exports them alongside the web-only pieces.
// The guided flows (GuidedPhotoWorkflow) walk the order by construction;
// these helpers gate the per-slot side channel (PhotoUploadSection) and the
// checklist so nothing can run ahead of the flow outside the guided path.
//
// One deliberate exception: the guided start-work flow uploads before photos
// while the appointment is still "accepted" (they are captured as part of the
// start-work ceremony, after the front-door photo, and the status flips on
// submit). That is why these gates live in the UI components, not the upload
// path.

export {
  allBeforePhotosUploaded,
  canUploadBeforePhotos,
  getAfterPhotoLockMessage,
  getBeforePhotoLockMessage,
  getChecklistLockMessage,
  getDistinctWorkflowDescription,
  getMissingPhotoSummary,
  getMissingWorkflows,
  getWorkflowPhoto,
} from "@shyne/shared";
export type { AfterPhotoGateInput, MissingPhotoSummary } from "@shyne/shared";

// Fail-closed guard, web only (mobile's loader fails its whole page instead):
// until the photo-workflow fetch succeeds, an empty serviceWorkflows array is
// indistinguishable from a service with no photo requirements, so every gate
// in this module would pass vacuously. Begin Tasks / Complete Work show this
// message and refuse to proceed while useAppointmentChecklist's
// workflowsLoaded is false.
export const WORKFLOWS_NOT_LOADED_MESSAGE =
  "Photo requirements haven't loaded yet. Retry from the Service Tasks section or reload the page.";
